"use client";

import { useState, useEffect } from "react";
import { useStoreSettingsContext } from "@/providers/StoreSettingsContextProvider";
import useRegionAndLocale from "./useRegionAndLocale";

export const useCertificationMessage = (certs: string[] | undefined) => {
	const [message, setMessage] = useState<string>("");

	// Move the hook call to the top level
	const storeSettings = useStoreSettingsContext();
	const { locale } = useRegionAndLocale();
	const certificationMessageText = storeSettings.certificationMessageText;

	useEffect(() => {
		if (!certs || !certs.length) {
			setMessage("");
			return;
		}

		const certificationList = certs.join(", ");
		const count = certs.length;

		let customMessage = "";
		if (typeof certificationMessageText === "string") {
			customMessage = certificationMessageText;
		} else if (
			certificationMessageText &&
			typeof certificationMessageText === "object"
		) {
			// Handle LocalizedValue object from Builder.io
			const localized = certificationMessageText as any;
			customMessage = localized[locale] || localized.Default || "";
		}

		// If no custom message is set in store settings, use default templates
		if (!customMessage) {
			const templates = {
				single: `${certificationList} authorization required`,
				plural: `${certificationList} authorizations required`,
			};

			const template = count === 1 ? templates.single : templates.plural;
			setMessage(template);
		} else {
			// Use the custom message from store settings
			setMessage(`${certificationList} ${customMessage}`);
		}
	}, [certs, certificationMessageText, locale]);

	return message;
};
